import React, { useState } from 'react';
import Button, { ButtonProps } from './Button';
import makeStyles from '@mui/styles/makeStyles';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import acceptButton from 'assets/images/acceptButton.png';
import rejectButton from 'assets/images/tour/button/close.png';
import printButton from 'assets/images/printButton.png';
import uploadButton from 'assets/images/uploadButton.png';
import photoButton from 'assets/images/photoButton.png';
import { STUDENT_APP_BUTTON_SIZES } from '@monorepo/shared/src/types';

const t = (key: string) => translate('a11y', key);

const hoveredImageMap = {
  acceptButton: acceptButton,
  rejectButton: rejectButton,
  printButton: printButton,
  uploadButton: uploadButton,
  photoButton: photoButton,
};

const notHoveredImageMap = {
  acceptButton: acceptButton,
  rejectButton: rejectButton,
  printButton: printButton,
  uploadButton: uploadButton,
  photoButton: photoButton,
};

export type ImageButtonProps = ButtonProps & {
  hoveredImgSrc?: string;
  notHoveredImgSrc?: string;
  imgAlt?: string;
  imageName?: string;
};

const ImageButton: React.FC<ImageButtonProps> = ({
  hoveredImgSrc,
  notHoveredImgSrc,
  imgAlt,
  imageName,
  ...rest
}) => {
  const classes = styles();
  const [isHoveredUpon, setIsHoveredUpon] = useState(false);
  const { imageClass, ...restClasses } = classes;

  const hoveredImage = imageName ? hoveredImageMap[imageName] : hoveredImgSrc;
  const notHoveredImage = imageName ? notHoveredImageMap[imageName] : notHoveredImgSrc;

  return (
    <Button classes={{ ...restClasses }} {...rest}>
      <img
        alt={imageName ? t(`alt.${imageName}`) : imgAlt}
        className={imageClass}
        onMouseEnter={() => setIsHoveredUpon(true)}
        onMouseLeave={() => setIsHoveredUpon(false)}
        src={isHoveredUpon ? hoveredImage : notHoveredImage}
      />
    </Button>
  );
};

const styles = makeStyles((theme) => ({
  root: {
    width: theme.typography.pxToRem(STUDENT_APP_BUTTON_SIZES.default),
    height: theme.typography.pxToRem(STUDENT_APP_BUTTON_SIZES.default),
    background: 'transparent',
    border: 'none',
    boxShadow: '0 4px 0 0 rgba(0,0,0,0.5);',
    '&:hover': {
      background: 'transparent',
    },
  },
  label: {
    '&:hover': {
      boxShadow: 'none',
    },
  },
  imageClass: {
    width: '100%',
    height: '100%',
  },
}));

export default ImageButton;
